import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';

type FilterModalPillSelectorProps = {
    title: string;
    items: string[];
    selectedItems: string[];
    onToggle: (item: string) => void;
    columns?: number; // for equal-width pills like categories (default 3)
    iconResolver?: (item: string) => string | undefined;
    includeAllPill?: boolean;
    allLabel?: string;
    onSelectAll?: () => void;
    allIconName?: string;
};

const FilterModalPillSelector = ({ title, items, selectedItems, onToggle, columns = 3, iconResolver, includeAllPill = false, allLabel = 'All', onSelectAll, allIconName = 'select-all' }: FilterModalPillSelectorProps) => {
    const flexBasisPercent = `${(100 / columns) - 2}%`;
    return (
        <View style={{ marginBottom: 24 }}>
            <Text style={styles.sectionTitle}>{title}</Text>
            <View style={[styles.container, { backgroundColor: '#FFFFFF', borderRadius: 16, padding: 8, borderWidth: 1, borderColor: '#E5E7EB' }]}>
                {includeAllPill && (
                    <TouchableOpacity
                        onPress={() => onSelectAll && onSelectAll()}
                        style={[styles.pill, selectedItems.length === 0 && styles.pillSelected, { flexBasis: flexBasisPercent }]}
                    >
                        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}>
                            {!!allIconName && (
                                <MaterialCommunityIcons
                                    name={allIconName as any}
                                    size={16}
                                    color={selectedItems.length === 0 ? '#FFFFFF' : '#374151'}
                                />
                            )}
                            <Text style={{ color: selectedItems.length === 0 ? '#FFFFFF' : '#111827', fontWeight: '600' }}>{allLabel}</Text>
                        </View>
                    </TouchableOpacity>
                )}
                {items.map((item, idx) => {
                    const isSelected = selectedItems.includes(item);
                    const iconName = iconResolver ? iconResolver(item) : undefined;
                    return (
                        <TouchableOpacity
                            key={idx}
                            onPress={() => onToggle(item)}
                            style={[styles.pill, isSelected && styles.pillSelected, { flexBasis: flexBasisPercent }]}
                        >
                            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}>
                                {iconName ? (
                                    <MaterialCommunityIcons
                                        name={iconName as any}
                                        size={16}
                                        color={isSelected ? '#FFFFFF' : '#374151'}
                                    />
                                ) : null}
                                <Text style={{ color: isSelected ? '#FFFFFF' : '#111827', fontWeight: '600' }}>{item}</Text>
                            </View>
                        </TouchableOpacity>
                    );
                })}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    sectionTitle: {
        fontSize: 16,
        fontWeight: '700',
        marginBottom: 14,
        color: '#111827'
    },
    container: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        width: '100%',
    },
    pill: {
        paddingHorizontal: 14,
        paddingVertical: 10,
        borderRadius: 999,
        backgroundColor: 'white',
        borderWidth: 1,
        borderColor: '#E5E7EB',
        margin: 6,
        alignItems: 'center',
        justifyContent: 'center',
        shadowColor: '#000',
        shadowOpacity: 0.04,
        shadowRadius: 4,
        shadowOffset: { width: 0, height: 2 },
        elevation: 1,
    },
    pillSelected: {
        backgroundColor: '#3C8248',
    },
});

export default FilterModalPillSelector;


